import { render } from "./CampaignStatusBadge.vue?vue&type=template&id=6c1d7cf3"
import script from "./CampaignStatusBadge.vue?vue&type=script&lang=js"
export * from "./CampaignStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__